import { useState, useEffect, useContext } from "react";
import { SiteContext } from "../contexts/SiteContext";
import {
	Typography,
	Card,
	CardActionArea,
	CardContent,
	makeStyles,
} from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	card: {
		marginBottom: "1rem",
	},
	link: {
		textDecoration: "none",
		'& h4': {
			textDecoration: 'underline'
		}
	},
	cardActionArea: {
		display: "flex",
		justifyContent: "start",
	},
	cardContent: {
		padding: 0,
	},
	subUnitDescription: {
		color: 'black',
		marginTop: '.5rem',
		marginBottom: '1rem'
	}
}));

function Units({ parentUnit }) {
	const [subUnits, setSubUnits] = useState();
	const [loading, setLoading] = useState(true);
	useEffect(() => {
		const fetchData = async () => {
			const url = `${process.env.REACT_APP_API_URL}/units?sort=sortDate&parent=${parentUnit._id}`;
			console.log(url);
			const res = await fetch(url, { credentials: "include" });
			let allUnits = await res.json();
			if (allUnits.success) {
				// Filter out all unpublished units
				setSubUnits(allUnits.data.filter((x) => x.published));
			} else {
				console.log(allUnits.error);
			}
		};
		fetchData();
		setLoading(false);
	}, [parentUnit]);

	if (loading || !subUnits) {
		return "Loading...";
	}

	return (
		<>
			{subUnits && subUnits.length > 0 && (
				<SubUnitsList subUnits={subUnits} />
			)}
		</>
	);
}

//----------
// LIST VIEW
//----------

function SubUnitsList({ subUnits }) {
	const classes = useStyles();
	const { selectedSite } = useContext(SiteContext);

	if (!subUnits) {
		return "Please pass subUnits to the SubUnitsList component...";
	}

	return (
		<>
			{subUnits.map((subUnit, index) => {
				return (
					<Card elevation={0} key={index} className={classes.card}>
						<Link
							className={classes.link}
							to={`/${selectedSite.slug}/units/${subUnit.slug}`}
						>
							<CardActionArea className={classes.cardActionArea}>
								<CardContent className={classes.cardContent}>
									<Typography variant="h6" component="h4">
										{subUnit.name}
									</Typography>
									<Typography
										component="p"
										className={classes.subUnitDescription}
										dangerouslySetInnerHTML={{
											__html: subUnit.shortDescription,
										}}
									></Typography>
								</CardContent>
							</CardActionArea>
						</Link>
					</Card>
				);
			})}
		</>
	);
}

export default Units;
